export default "__VITE_ASSET__7fb94355__"